import { Component, ComponentInterface, h, State } from '@stencil/core';
import state from '../../../store';

@Component({
  tag: 'app-gdpr',
  styleUrl: 'style.scss',
  shadow: false
})
export class AppHeader implements ComponentInterface {
  @State() customizeBtn: boolean = false;
  @State() customizeMarketingBtn: boolean = false;
  @State() customizeStatisticsBtn: boolean = false;

  /**
   * Set necessary scripts
   */
  necessary() {
    window['civchat'] = {
      apiKey: process.env.USERCHAT,
    };
  }

  /**
   * Set google analytics
   */
  googleTagManager() {
    (function(w,d,s,l,i){
      w[l]=w[l]||[];w[l].push({
        'gtm.start':new Date().getTime(),
        event:'gtm.js'
      });

      var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),
          dl=l!='dataLayer'?'&l='+l:'';

      (j as any).async=true;
      (j as any).src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', `${process.env.GTM}`);
  }

  /**
   * Customize cookies and hide modal
   */
  saveGdpr = () => {
    state.gdprEnabled  = false;
    state.gdprEnabledFooter = false;
    this.setCookie('gdpr-enabled', true, 30);

    const marketing = this.getCookieValue('marketing');
    const statistics = this.getCookieValue('statistics');

    if (marketing) {
      this.googleTagManager();
    }

    if (statistics) {
      // Add statistics scripts
    }
  }

  /**
   * Accept all cookies and hide modal
   */
  acceptAll = () => {
    state.gdprEnabled  = false;
    state.gdprEnabledFooter = false;
    this.setCookie('marketing', true, 30);
    this.setCookie('statistics', true, 30);
    this.setCookie('gdpr-enabled', true, 30);

    const marketing = this.getCookieValue('marketing');
    const statistics = this.getCookieValue('statistics');


    if (marketing) {
      this.googleTagManager();
    }

    if (statistics) {
    }
  }

  /**
   * Show customize gdpr cookies
   */
  customize = () => {
    this.customizeBtn = !this.customizeBtn;
  }

  /**
   * Show customize gdpr cookies
   */
  customizeMarketing = () => {
    this.customizeMarketingBtn = !this.customizeMarketingBtn;

    if (this.getCookieValue('marketing')) {
      this.customizeMarketingBtn = false;
    } else {
      this.customizeMarketingBtn = true;
    }

    this.setCookie('marketing', this.customizeMarketingBtn, 30);
  }

  /**
   * Return cookie marketing
   */
  getCookieMargeting() {
    if (this.getCookieValue('marketing')) {
      return true;
    }

    return false;
  }

  /**
   * Show customize gdpr cookies
   */
  customizeStatistics = () => {
    this.customizeStatisticsBtn = !this.customizeStatisticsBtn;

    if (this.getCookieValue('statistics')) {
      this.customizeStatisticsBtn = false;
    } else {
      this.customizeStatisticsBtn = true;
    }

    this.setCookie('statistics', this.customizeStatisticsBtn, 30);
  }

  /**
   * Return cookie statistics
   */
  getCookieStatistics() {
    if (this.getCookieValue('statistics')) {
      return true;
    }

    return false;
  }

  /**
   * Set cookie name
   */
  setCookie(name, value, days) {
    let expires = "";

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  /**
   * Get cookie name
   */
  getCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');

      for(let i=0;i < ca.length;i++) {
          let c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }

      return null;
  }

  /**
   * Get cookie value
   */
  getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  /**
   * Erase cookie name
   */
  eraseCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  componentDidLoad() {
    this.necessary();

    state.gdprEnabledFooter = false;

    if (!this.getCookieValue('gdpr-enabled') && state.gdprEnabledFooter === false) {
      state.gdprEnabled = true;
    }

    if (this.getCookieMargeting()) {
      this.googleTagManager();
    }
  }

  render() {
    return (
      <div>
        {
          state.gdprEnabledFooter ||
          (state.gdprEnabled && !this.getCookieValue('gdpr-enabled')) ?
            <div class={
              {
                'gdpr-drawer': true,
                'gdpr-enabled': state.gdprEnabled || state.gdprEnabledFooter,
              }
            }>
              <div class='gdpr-wrapper'>
                <div class='gdpr-content'>
                  <div class='gdpr-box'>
                    <p>Ta strona używa plików cookies</p>
                    <p>Używamy plików cookie do personalizowania treści i reklam, udostępniania funkcji mediów społecznościowych i analizowania naszego ruchu. Udostępniamy również informacje o korzystaniu przez Ciebie z naszej witryny naszym partnerom w zakresie mediów społecznościowych, reklam i analiz, którzy mogą łączyć je z innymi informacjami, które dostarczyłeś lub zebrałeś podczas korzystania z ich usług. Jeśli nadal korzystasz z naszej witryny wyrażasz zgodę na nasze pliki cookie.</p>
                    {
                    this.customizeBtn ?
                      <ul>
                        <li class={
                          {
                            'active': true,
                          }
                        }
                        >
                          <label>
                            <span class='label-switch'/>
                            <span class='label'>Niezbędny</span>
                          </label>
                        </li>
                        <li class={
                          {
                            'active': this.customizeMarketingBtn || this.getCookieMargeting(),
                          }
                        }
                        onClick={ this.customizeMarketing }
                        >
                          <label>
                            <span class='label-switch'/>
                            <span class='label'>Marketing</span>
                          </label>
                        </li>
                        <li class={
                          {
                            'active': this.customizeStatisticsBtn || this.getCookieStatistics(),
                          }
                        }
                        onClick={ this.customizeStatistics }
                        >
                          <label>
                            <span class='label-switch'/>
                            <span class='label'>Statystyka</span>
                          </label>
                        </li>
                      </ul> :
                      null
                  }
                  </div>
                  <div class='gdpr-actions'>
                    <ul>
                      {
                        this.customizeBtn ?
                          <li>
                            <button
                              class='save'
                              onClick={ this.saveGdpr }
                            >
                              Zapisać
                            </button>
                          </li> :
                          !this.customizeBtn ?
                            <li>
                              <button
                                class='customize'
                                onClick={ this.customize }
                              >
                                Dostosuj
                              </button>
                            </li> :
                            null
                      }
                      <li>
                        <button
                          class='accept-all'
                          onClick={ this.acceptAll }
                        >
                          Zaakceptuj
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> :
            null
        }

        {
          this.getCookieStatistics() ?
            <div>
              {/* Add your statistics code */}
            </div> :
            null
        }

        {
          this.getCookieMargeting() ?
            <noscript>
              <iframe src={"https://www.googletagmanager.com/ns.html?id=" + process.env.GTM} height="0" width="0" />
            </noscript> :
            null
        }
      </div>
    );
  }
}
